<div class="col-12 col-xl-8">
  <div class="entity-binding-workspace bg-white bg-opacity-75 rounded-4 border shadow p-3 h-100">
    <div class="d-flex flex-wrap align-items-start justify-content-between gap-2 mb-1">
      <div>
        <h2 class="fs-5 fw-bold mb-1">Active Template Bindings</h2>
        <div class="entity-panel-caption small fw-semibold">
          Connect uploaded templates to this entity configuration.
        </div>
      </div>
      <span class="entity-detail-pill entity-status-active rounded-pill fw-bold text-uppercase">
        {{ bound_templates_count }} Active
      </span>
    </div>

    <div class="entity-new-binding-card bg-white rounded-4 border p-3 mb-3 mt-3 shadow">
      <div class="d-flex align-items-start gap-2 mb-3">
        <div class="entity-new-binding-icon rounded-3 d-inline-flex align-items-center justify-content-center">
          <i class="bi bi-link-45deg"></i>
        </div>
        <div>
          <div class="fw-bold text-xs mb-1">Add Template Binding</div>
          <div class="entity-panel-caption text-xxs fw-semibold">
            Bind an uploaded template to this entity setup.
          </div>
        </div>
      </div>

      <div class="row g-3 align-items-end">
        <div class="col-12 col-lg-8">
          <label class="form-label mb-1 fw-semibold text-xs">Select Template</label>
          <div ref="templateMultiselect" class="position-relative">
            <div
              class="form-select subsystem-select entity-binding-control rounded-small p-2 shadow-sm d-flex align-items-center justify-content-between cursor-pointer user-select-none"
              :class="{ disabled: loading || creating_template_binding }" @click="toggle_template_dropdown">
              <span :class="selected_templates_count ? 'text-dark' : 'text-muted'">
                {{ selected_templates_label }}
              </span>
              <i class="bi bi-chevron-down ms-2 small"></i>
            </div>

            <div v-if="template_dropdown_open"
              class="position-absolute start-0 end-0 bg-white border rounded-small mt-1 overflow-auto entity-template-dropdown">
              <div v-if="loading" class="px-3 py-2 text-muted small">Loading templates...</div>
              <div v-else-if="!bindable_templates.length" class="px-3 py-2 text-muted small">No templates available
              </div>
              <label v-else v-for="template in bindable_templates" :key="template.id"
                class="d-flex align-items-center gap-2 px-3 py-2 mb-0 text-xs cursor-pointer"
                :class="selected_template_ids.includes(String(template.id)) ? 'bg-light' : ''">
                <input type="checkbox" :value="String(template.id)" v-model="selected_template_ids"
                  class="form-check-input mt-0 flex-shrink-0" />
                {{ template.name }}
              </label>
            </div>
          </div>
        </div>

        <div class="col-12 col-lg-3">
          <button type="button"
            class="btn entity-create-binding-btn rounded-small shadow-sm px-3 py-2 fw-semibold border-0 text-white w-100"
            :disabled="creating_template_binding || !selected_templates_count" @click="add_template_bindings">
            <i class="bi bi-link-45deg me-2"></i>
            {{ creating_template_binding ? 'Binding...' : selected_templates_count > 1 ? `Bind
            ${selected_templates_count} Templates` : 'Bind Template' }}
          </button>
        </div>
      </div>
    </div>

    <div class="d-flex align-items-center justify-content-between gap-2 mb-2">
      <div class="fw-bold small">Current Template Bindings</div>
      <div class="entity-panel-caption small fw-semibold">{{ bound_templates_count }} configured</div>
    </div>

    <div class="d-flex flex-column gap-2">
      <div v-for="binding in template_bindings" :key="binding.id"
        class="entity-binding-list-card bg-white d-flex align-items-start justify-content-between gap-3 rounded-4 p-3 shadow-sm">
        <div class="d-flex align-items-start gap-3 flex-grow-1 overflow-hidden">
          <div
            class="entity-summary-icon rounded-3 d-inline-flex align-items-center justify-content-center flex-shrink-0 align-self-stretch">
            <i class="bi bi-file-earmark-pdf fs-4"></i>
          </div>
          <div class="flex-grow-1 overflow-hidden">
            <div class="fw-bold small text-truncate mb-1">{{ binding.name || 'Template' }}</div>
            <div v-if="binding.type" class="fw-bold small text-uppercase entity-mini-label d-inline-block">
              {{ binding.type }}
            </div>
          </div>
        </div>

        <div class="d-flex flex-column align-items-end gap-2 flex-shrink-0">
          <button type="button"
            class="btn btn-link btn-sm p-0 text-danger text-decoration-none small fw-semibold d-inline-flex align-items-center justify-content-end gap-2 text-nowrap"
            @click="unassign_template_binding(binding)">
            <i class="bi bi-trash3"></i>Remove </button>
        </div>
      </div>

      <div v-if="!template_bindings.length" class="entity-activity-card rounded-4 p-3 small text-secondary bg-white">
        No template bindings yet. Add a template above.
      </div>
    </div>

  </div>
</div>

<div class="col-12 col-xl-4">
  <div class="entity-overview-profile-card rounded-4 border shadow p-4 h-100 overflow-hidden">
    <h2 class="entity-overview-title fw-bold mb-3">Templates Context</h2>
    <div class="small mb-4">
      <div class="entity-panel-caption fw-semibold">Viewing templates for</div>
      <div class="fw-bold">{{ entityTypeName || 'Entity' }}</div>
    </div>

    <div class="d-flex flex-column gap-3 my-4">
      <div class="d-flex align-items-center justify-content-between gap-2">
        <span class="small text-secondary">Bound Templates</span>
        <span class="small fw-bold">{{ bound_templates_count }}</span>
      </div>
    </div>

    <button type="button" class="btn entity-overview-profile-btn rounded-small w-100 text-xs fw-semibold"
      @click="go_to_entity_overview">
      <i class="bi bi-eye me-2"></i>
      View Entity Overview
    </button>
  </div>
</div>